<template>
  <div class="c-mixcheck">
    <slot></slot>
  </div>
</template>

<script type="text/ecmascript-6">
import { findComponentsDownward } from '@/common/js/assist'
import { isArray } from '@/common/js/utils'

export default {
  name: 'Mixcheck',
  props: {
    value: {
      type: [Array, String, Number],
      default: '',
      required: true
    }
  },
  methods: {
    updateModel() {
      const { value, $children: children } = this
      for (const child of children) {
        child.model = value
        child.currentValue = false
      }
      const radioChildrens = findComponentsDownward(this, 'RadioItem')
      const checkChildrens = findComponentsDownward(this, 'CheckItem')
      if (isArray(value)) {
        for (const ret of checkChildrens) {
          ret.currentValue = value.indexOf(ret.label) > -1
        }
      } else {
        const index = radioChildrens.findIndex((ret) => ret.label === value)
        if (index > -1) radioChildrens[index].currentValue = true
      }
    },

    /**
     * @description: 被子组件触发：例如check-item this.$parent.change(model)
     * @param {*} data
     */
    change(data) {
      this.$emit('input', data)
      this.$emit('on-change', data)
    }
  },
  watch: {
    value: {
      handler(nVal, oVal) {
        this.$nextTick(() => {
          this.updateModel()
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-mixcheck {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  font-size: 0;

  ::v-deep .mixcheck-item {
    display: inline-block;
    font-size: 12px;
    height: 32px;
    line-height: 30px;
    padding: 0px 15px;
    color: #333;
    cursor: pointer;
    user-select: none;
    background-color: #fff;
    border: 1px solid #dcdee2;
    margin-left: -1px; // 消除边框重叠
    // border-left: 0;

    &:first-child {
      border-left: 1px solid #dcdee2;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &.c-wrapper-checked {
      color: $primary-color;
      border-color: $primary-color;
      box-shadow: 0px 0px 1px 0px $primary-color;
      z-index: 1;

      &:first-child {
        box-shadow: none;
      }

      &:after {
        border-left-color: $primary-color;
      }
    }

    &.c-wrapper-disabled {
      color: #cccccc;
      background-color: #f7f7f7;
      border-color: #dcdee2;
      cursor: not-allowed;
      box-shadow: none !important;

      &:first-child {
        border-left-color: #dcdee2;
      }

      &.c-wrapper-checked {
        color: #ffffff;
        background-color: #e6e6e6;

        &:after {
          border-left-color: #95b5d6;
        }
      }
    }

    .c-mix-input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
}
</style>
